import script from "./ZiRevenueHeadcount+RevenueHeadcount+RevLastUpdatedCell.vue?vue&type=script&setup=true&lang=js"
export * from "./ZiRevenueHeadcount+RevenueHeadcount+RevLastUpdatedCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__